import React from "react";
import { useBetslipStore } from "@/features/betslip/stores/betslipStore";
import { useUpdatesSync } from "@/features/betslip/hooks/useUpdatesSync";
import { useSemOdds } from "@/features/betslip/hooks/useSemOdds";
import { useQuaddieStatusSync } from "@/features/betslip/hooks/useQuaddieStatusSync";
import type {
  UpdatesSyncTarget,
  QuaddieStatusTarget,
} from "@/features/betslip/stores/types";

const OutcomeSubscription = (target: UpdatesSyncTarget) => {
  useUpdatesSync(target);
  return null;
};

const SemPricingSubscription = ({ outcomeId }: { outcomeId: string }) => {
  useSemOdds(outcomeId);
  return null;
};

const QuaddieSubscription = ({ outcomeId, marketId }: QuaddieStatusTarget) => {
  useQuaddieStatusSync(outcomeId, marketId);
  return null;
};

export const OutcomeSubscriptions = () => {
  const targets = useBetslipStore((s) => s.updatesSyncTargets);
  const semPricingIds = useBetslipStore((s) => s.semPricingIds);
  const quaddieTargets = useBetslipStore((s) => s.quaddieStatusTargets);

  return (
    <>
      {targets.map((target) => (
        <OutcomeSubscription
          key={
            target.sem
              ? `${target.sem.outcomeId}:${target.outcomeId}`
              : target.statusId
          }
          {...target}
        />
      ))}
      {semPricingIds.map((outcomeId) => (
        <SemPricingSubscription key={outcomeId} outcomeId={outcomeId} />
      ))}
      {quaddieTargets.map((target) => (
        <QuaddieSubscription
          key={target.outcomeId}
          outcomeId={target.outcomeId}
          marketId={target.marketId}
        />
      ))}
    </>
  );
};
